import { render, staticRenderFns } from "./EMelderComponentMeldungenChatRightMessage.vue?vue&type=template&id=37321e4a&scoped=true"
import script from "./EMelderComponentMeldungenChatRightMessage.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldungenChatRightMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37321e4a",
  null
  
)

export default component.exports